export const extraSite = ['www.lujing56.cn', 'www.sxlyt56.com', 'www.lujing56.com'];

export const v1Member = {
  product: 'https://v1.tf56.com',
  test: 'https://v1test.tf56.com'
};

export const SiteMap = {
  product: ['lyt.tf56.com'],
  test: ['lyttest.tf56.com'],
  develop: ['mytest.tf56.com'],
  extraSite
};

const host = window.location.host;

export const isProductFn = () =>{
    const isProduct = SiteMap.product.some(i => host.indexOf(i) > -1);
    return isProduct;
  }
  export const isTestFn = () =>{
    const isTest = SiteMap.test.some(i => host.indexOf(i) > -1);
    return isTest;
  };
  export const isDevFn = () =>{
    const isDev = SiteMap.develop.some(i => host.indexOf(i) > -1);
    return isDev;
  }

  export const isExtra = () => {
    const isExtra = SiteMap.extraSite.some(i => host.indexOf(i) > -1);
    return isExtra;
  }

  export const getPreviewHost =() => {
    // doc\execl文件预览地址
    const host = isDevFn() || isTestFn() ? 'https://onlineviewtest.tf56.com' : 'https://onlineview.tf56.com';
    return host;
  }


// WEBPACK FOOTER //
// ./src/utils/siteTools.js